module.exports = __webpack_public_path__ + "static/media/kid20.0773b293.png";